// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-body);
  background-color: var(--surface-page);
  color: var(--text-primary);
  line-height: 1.6;
}

a,
a:visited {
  color: var(--text-accent);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
}

h1 {
  font-size: 2.4rem !important;
}

h2 {
  font-size: 1.75rem;
}

h1,
h2,
h3,
h4 {
  font-family: var(--font-heading);
  color: var(--text-primary);
  margin-top: 0;
  line-height: 1.2;
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.page-content {
  flex: 1;
}

.container {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 24px;
}

.btn,
.btn:visited {
  display: inline-block;
  background-color: var(--interactive-default);
  color: var(--interactive-label);
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 999px;
  border: 2px solid var(--interactive-edge);
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.15s ease;
}

/* <button> doesn't inherit the page font by default, so a .btn button would
   otherwise render smaller than a .btn link. */
button.btn {
  font: inherit;
  font-weight: 600;
}

.btn:hover {
  background-color: var(--interactive-hover);
  color: var(--interactive-label);
  text-decoration: none;
  transform: translateY(-1px);
}

/* Only matches form controls — .btn is used on anchors too, and those can't
   be disabled. Without this a disabled button keeps .btn's pointer. */
.btn:disabled {
  cursor: not-allowed;
  transform: none;
}

/* Coral-deep, not coral — as text and as a border this has to carry contrast
   on its own (4.81 on the page) rather than sit under a label. */
/* Filled white rather than transparent, so it reads as a button on the page
   instead of letting the background through. The white sits only 1.15 against
   the page, so the 2px coral-deep border is what carries the edge — and that
   border is also why this still reads as a control on the white panels it
   appears on (Thank You, Donate), where the fill matches its surface. */
.btn-outline,
.btn-outline:visited {
  background-color: var(--surface-raised);
  color: var(--text-accent);
  border: 2px solid var(--text-accent);
}

.btn-outline:hover {
  background-color: var(--interactive-default);
  border-color: var(--interactive-edge);
  color: var(--interactive-label);
}

section {
  padding: 36px 0;
}

.section-alt {
  padding: 24px;
  background-color: var(--surface-sunken);
}

.section-heading {
  text-align: center;
  margin-bottom: 24px;
}

.section-heading p {
  color: var(--text-primary);
  opacity: 0.8;
  max-width: 640px;
  margin: 8px auto 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,eAAe;EACf,6DAA6D;AAC/D;;AAEA;+CAC+C;AAC/C;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;sEACsE;AACtE;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;iEACiE;AACjE;;;;wEAIwE;AACxE;;EAEE,uCAAuC;EACvC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: var(--font-body);\n  background-color: var(--surface-page);\n  color: var(--text-primary);\n  line-height: 1.6;\n}\n\na,\na:visited {\n  color: var(--text-accent);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n:focus-visible {\n  outline: 3px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\nh1 {\n  font-size: 2.4rem !important;\n}\n\nh2 {\n  font-size: 1.75rem;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  font-family: var(--font-heading);\n  color: var(--text-primary);\n  margin-top: 0;\n  line-height: 1.2;\n}\n\n.page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.page-content {\n  flex: 1;\n}\n\n.container {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.btn,\n.btn:visited {\n  display: inline-block;\n  background-color: var(--interactive-default);\n  color: var(--interactive-label);\n  font-weight: 600;\n  padding: 12px 28px;\n  border-radius: 999px;\n  border: 2px solid var(--interactive-edge);\n  cursor: pointer;\n  transition: background-color 0.15s ease, transform 0.15s ease;\n}\n\n/* <button> doesn't inherit the page font by default, so a .btn button would\n   otherwise render smaller than a .btn link. */\nbutton.btn {\n  font: inherit;\n  font-weight: 600;\n}\n\n.btn:hover {\n  background-color: var(--interactive-hover);\n  color: var(--interactive-label);\n  text-decoration: none;\n  transform: translateY(-1px);\n}\n\n/* Only matches form controls — .btn is used on anchors too, and those can't\n   be disabled. Without this a disabled button keeps .btn's pointer. */\n.btn:disabled {\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Coral-deep, not coral — as text and as a border this has to carry contrast\n   on its own (4.81 on the page) rather than sit under a label. */\n/* Filled white rather than transparent, so it reads as a button on the page\n   instead of letting the background through. The white sits only 1.15 against\n   the page, so the 2px coral-deep border is what carries the edge — and that\n   border is also why this still reads as a control on the white panels it\n   appears on (Thank You, Donate), where the fill matches its surface. */\n.btn-outline,\n.btn-outline:visited {\n  background-color: var(--surface-raised);\n  color: var(--text-accent);\n  border: 2px solid var(--text-accent);\n}\n\n.btn-outline:hover {\n  background-color: var(--interactive-default);\n  border-color: var(--interactive-edge);\n  color: var(--interactive-label);\n}\n\nsection {\n  padding: 36px 0;\n}\n\n.section-alt {\n  padding: 24px;\n  background-color: var(--surface-sunken);\n}\n\n.section-heading {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.section-heading p {\n  color: var(--text-primary);\n  opacity: 0.8;\n  max-width: 640px;\n  margin: 8px auto 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
